import { Helmet } from 'react-helmet-async';
import { useState } from 'react';
import './portfolioPage.css';
import PortfolioHeader from '../../components/portfolioHeader/PortfolioHeader';
import PortfolioProjectHem from '../../components/portfolioProjectHem/PortfolioProjectHem';
import PortfolioProjectKlar from '../../components/portfolioProjectKlar/PortfolioProjectKlar';
import PortfolioProjectMovz from '../../components/portfolioProjectMovz/PortfolioProjectMovz';
import PortfolioProjectAlpineSport from '../../components/portfolioProjectAlpineSport/PortfolioProjectAlpineSport';

import CirclePortrait from '../../assets/portfolio/circle-portrait.png';
import MovzScreen from '../../assets/portfolio/movz-screen.png';
import AlpineScreen from '../../assets/portfolio/alpine-screen.png';
import KlarScreen from '../../assets/portfolio/klaralv-screen.png';
import HemScreen from '../../assets/portfolio/hem-screen.png';

const skills = [
    'Figma',
    'User Centered Design',
    'Leadership',
    'Design Thinking',
    'Agile Work Methods',
    'SEO',
    'English',
    'Creative',
    'Testing',
    'Critical Thinking',
    'AWS',
    'Digital Marketing',
    'Planning',
    'CSS',
    'Colour & Form',
    'Typescript',
    'Ödmjuk',
    'Frontend Development',
    'Swedish',
    'WCAG',
    'Wireframing',
    'UX/UI',
    'Google Analytics',
    'Tailwind',
    'HTML',
    'React',
    'Scrum',
    'Research',
    'Ideating',
    'Personas'
];

function PortfolioPage() {

    const [activeProject, setActiveProject] = useState<string | null>(null);

    return (
        <div className='portfolioPage-container'>
            <Helmet>
                <title>Alistair McCann – Frontend Developer & UX designer</title>
                <meta name="description" content="Welcome to Alistair McCann's portfolio page. Frontend developer, UX designer and SEO specialist." />
                <meta property="og:title" content="Alistair McCann - Portfolio" />
                <meta property="og:description" content="Welcome to Alistair McCann's portfolio page. Frontend developer, UX designer and SEO specialist." />
                <link rel="icon" href="%PUBLIC_URL%/colours-favicon.png" type="image/png" />
                <meta property="og:url" content="https://alpinesport.se/portfolio" />
                <meta property="og:type" content="website" />
                <link rel="canonical" href="https://alpinesport.se/portfolio" />
            </Helmet>
            <PortfolioHeader />
            <main>
                <section id="aboutMe" className=" margin-top">
                    <h2 className='h2-portfolio'>About Me</h2>
                    <div className="aboutMe-content ">
                        
                        <article>
                            <p className='p-portfolio'>
                                <strong>Engaged and creative web developer & UX designer with experience in digital marketing, SEO and web analytics.</strong>  These combination of skills give me the tools i need to successfully develop a project from idea to finished product. I work in a structured way with clear strategies and measurable goals, driven by an interest in UX/UI to create clear customer journeys and increase search engine visibility. <br /><br />

                                Thanks to my knowledge of SEO and web content, I also ensure that the product ranks better in search engines, reaches the right target audience, delivers measurable results, and generates a higher conversion rate. <br /><br />

                                I’ve always been creative and been interested in art, photography and design, so it feels only natural that I was drawn to web development. I enroled on a frontend developer course, which was really much more than so. It included the whole development process from design, to frontend, backend and full-stack. Early on i realised what i wanted to focus on, it was UX that drew my real interest. The creative process and interactions with product owners and potential users fitted me exactly. <br /><br />

                                <strong>So what’s my UX style? </strong>I love a clean, easy to follow design with subtle animations to give a smooth flow. Lots of bling and large animations might look cool but make for an awfull user experience, so thats something i seldom use. I get a lot of inspiation from nature and abstract art for colours, transitions and layout. <br /><br />

                                I also have an interest in the more holistic side of the development process where I can use my structural, planning and people skills to help facilitate for other developers in the work process where I enjoy working in roles such as scrum master.
                            </p>
                        </article>
                        <aside>
                            <img className="portrait-image" src={CirclePortrait} alt="portrait" />
                        </aside>
                    </div>
                </section>


                <section className='skillsSection-container margin-top'>
                    <h2 className='h2-portfolio'>
                        Skills
                    </h2>

                    <div className='skills-list'>
                        {skills.map((skill, index) => (
                            <div key={index} className='skill-item'>
                                {skill}
                            </div>
                        ))}
                    </div>

                </section>

                <section id='projects' className='projectsSection-container margin-top'>
                    <h2 className='h2-portfolio'>
                        Projects
                    </h2>
                    {!activeProject && (
                        <section className='projectImages-container'>
                            <button onClick={() => setActiveProject('movz')} className='project-thumbnail'>
                                <img src={MovzScreen} alt="Movz Project" />
                            </button>
                            <button onClick={() => setActiveProject('alpine')} className='project-thumbnail'>
                                <img src={AlpineScreen} alt="Alpine Sport Project" />
                            </button>
                            <button onClick={() => setActiveProject('klar')} className='project-thumbnail'>
                                <img src={KlarScreen} alt="Klar Project" />
                            </button>
                            <button onClick={() => setActiveProject('hem')} className='project-thumbnail'>
                                <img src={HemScreen} alt="Hem Project" />
                            </button>
                        </section>
                    )}

                    {activeProject && (
                        <section className='projectDetail'>
                            {activeProject === 'movz' && <PortfolioProjectMovz />}
                            {activeProject === 'alpine' && <PortfolioProjectAlpineSport />}
                            {activeProject === 'klar' && <PortfolioProjectKlar />}
                            {activeProject === 'hem' && <PortfolioProjectHem />}

                            <button
                                className='backToProjects-btn'
                                onClick={() => setActiveProject(null)}
                            >
                                Back to Projects
                            </button>
                        </section>
                    )}
                </section>
            </main>
        </div >
    )
}

export default PortfolioPage
